import React from 'react';
import PropTypes from 'prop-types';

const styles = {
  cardContentP: { textAlign: 'center', fontSize: '1rem', marginBottom: 15, padding: 0 },
  cardContentDiv: { flex: 1, padding: '10px 5px' },
  card: {
    backgroundColor: '#FFFFFF',
    height: 90,
    display: 'flex',
    boxShadow: '0 1px 5px 0 rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12)',
    // border: '1px solid #e8e8e8',
    borderRadius: 2,
  },
};

const CustomerDashboardCard = (props) => (
  <div style={styles.card}>
    <div style={{ backgroundColor: props.bgColor, padding: '15px 10px' }}>
      <img src={props.image} alt={props.title} style={{ height: 60, width: 60 }} />
    </div>
    <div style={styles.cardContentDiv}>
      <p style={styles.cardContentP}>{props.title}</p>
      <h5 style={{ textAlign: 'center' }}>{props.percent}%</h5>
    </div>
  </div>
);

CustomerDashboardCard.propTypes = {
  bgColor: PropTypes.string.isRequired,
  image: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  percent: PropTypes.number,
};

CustomerDashboardCard.defaultProps = {
  percent: 0,
};

export default CustomerDashboardCard;



// WEBPACK FOOTER //
// ./src/components/CustomerDashboardCard.jsx